import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "mt-2 text-sm font-medium text-gray-900" }
const _hoisted_3 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_4 = {
  key: 0,
  class: "mt-6"
}


export default {
  __name: 'EmptyState',
  props: ['plural', 'description'],
  setup(__props) {

const props = __props

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("svg", {
      class: "mx-auto h-12 w-12 text-gray-400",
      fill: "none",
      viewBox: "0 0 24 24",
      stroke: "currentColor",
      "aria-hidden": "true"
    }, [
      _createElementVNode("path", {
        "vector-effect": "non-scaling-stroke",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
      })
    ], -1)),
    _createElementVNode("h3", _hoisted_2, "No " + _toDisplayString(props.plural || 'items'), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(props.description ?? 'Get started by adding a new one.'), 1),
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

}